import React from "react";
import PCM from "./PCM";
import PCB from "./PCB";
import "./SubjectCards.css";
import Commerce from "./Commerce";
import Humanities from "./Humanities";

const SubjectCards = () => {
  return (
    <div className="subject_cards">
      <div className="subject_cards_grid">
        <div className="columnn">
          <PCM />
        </div>
        <div className="columnn">
          <PCB />
        </div>
        <div className="columnn">
          <Commerce />
        </div>
        <div className="columnn">
          <Humanities />
        </div>
      </div>
    </div>
  );
};

export default SubjectCards;
